import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { Button as SButton } from '@/components/Button/Button'
import { IconWrapper, Label } from '@/components/Button/styles'

const gridSizeBasis = 0.5
const keySize = `${gridSizeBasis * 3}em`

export const Wrapper = styled(FocusNode)`
  padding-left: 2px;
  .isFocusedLeaf {
    box-shadow: ${({ theme }) => theme.colors.link} 0 0 0 2px;
  }
`
export const KeyboardLayoutGrid = styled(FocusNode)`
  display: table;
`
export const KeyboardLayoutRow = styled(FocusNode)`
  display: table-row;
`
export const KeyboardLayoutKey = styled(FocusNode)`
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: ${keySize};
  height: ${keySize};
  border-radius: 8px;
  overflow: hidden;
  font-size: 38px;
  font-weight: 700;

  &:last-child {
    margin-right: 0;
  }
`
export const SidebarButton = styled(FocusNode)`
  display: table-cell;
  height: ${keySize};
  width: 100px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }

  span {
    font-size: 22px;
    text-transform: uppercase;
    line-height: 1;
  }

  img {
    height: ${keySize};
    width: ${keySize};
  }

  span,
  img {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
export const Grid = styled(FocusNode)`
  padding-top: 2px;
  padding-left: 2px;

  &::after {
    content: '';
    display: block;
    clear: both;
  }
`
export const GridItem = styled.div`
  float: left;
`
export const RightActionBarWrapper = styled(FocusNode)`
  display: table;
`
export const SidebarButtonWrapper = styled.div`
  display: table-row;
`
export const FooterActionBarWrapper = styled(FocusNode)`
  display: flex;
  width: 15em;
  justify-content: space-between;
  padding-right: 1px;
`
export const Button = styled(SButton)<{
  hideLabel: boolean
}>`
  margin: 10px ${gridSizeBasis * 1}em 0 0;
  flex: 1 1 auto;
  flex: ${({ hideLabel }) => (hideLabel ? '0 0 auto' : '1 1 auto')};
  &:last-child {
    margin-right: 0;
  }
  & ${Label} {
    min-width: 0;
    text-transform: capitalize;
    font-size: 24px;
    font-weight: 400;
  }
  ${IconWrapper} {
    width: 62px;
    padding: 0;
    justify-content: center;
  }
`
